import {useMutation} from '@apollo/react-hooks';

import type {
    MarkNotificationAllSeen as MarkNotificationAllSeenMutation,
    MarkNotificationReadVariables as MarkNotificationReadMutationVariables,
} from 'nutshell-graphql-types';

import MARK_ALL_SEEN from '../graphql/mutations/mark-notification-all-seen.graphql';

export function useMarkAllSeen(): () => Promise<any> {
    const [markAllSeen] = useMutation<
        MarkNotificationAllSeenMutation,
        MarkNotificationReadMutationVariables
    >(MARK_ALL_SEEN);

    return () => {
        return markAllSeen();
    };
}
